import React from 'react';
import InputSelectCounty from './InputSelectCounty';
import Accordion from './Accordion';

export default function CompareCountiesStatsSelector({
  children: _children,
  activeCounty,
  activeCompareCounty,
  handleUpdateActiveCompareCounty,
  items,
  searchQuery,
  searchResults,
  setSearchQuery,
  isSearchResultsLoading,
  updateSelected,
}) {
  let broadbandItem = items.length !== 0 ? items?.[0] : null;
  let accordionItems = items.length !== 0 ? [items?.[1]] : null;

  return (
    <div
      data-component-name='CompareCountiesStatsSelector'
      className='bg-blue-50 rounded-lg p-4'
    >
      <div className='grid grid-cols-2 gap-4'>
        <div className='flex flex-col gap-2'>
          <span className='text-blue-300 text-xs'>County A</span>
          <InputSelectCounty disabled={true} activeCounty={activeCounty} color='green' />
        </div>

        <div className='flex flex-col gap-2'>
          <span className='text-blue-300 text-xs'>County B</span>
          <InputSelectCounty
            activeCounty={activeCompareCounty}
            handleUpdateActiveCompareCounty={handleUpdateActiveCompareCounty}
            searchQuery={searchQuery}
            searchResults={searchResults}
            setSearchQuery={setSearchQuery}
            isSearchResultsLoading={isSearchResultsLoading}
            updateSelected={updateSelected}
            color='pink'
          />
        </div>
      </div>

      <div className='mt-5'>
        {broadbandItem && (
          <div>
            <div className='pl-[15px]'>{broadbandItem.title}</div>
            <div className='flex gap-2.5 pt-3 pb-2 opacity-50'>
              <div className='border-b border-blue-100 flex-1'></div>
              <div className='border-b border-blue-100 flex-1 mr-1'></div>
            </div>
          </div>
        )}
        {accordionItems && (
          <Accordion
            items={accordionItems}
            chevronClasses='text-blue-200'
            variant='small'
          />
        )}
      </div>
    </div>
  );
}
